const qaTa = (id) => `[data-qa-ta="${id}"]`;
const testId = (id) => `[data-testid="${id}"]`;
const button = (name) => `button[name="${name}"]`;
const buttonQaTa = (name) => qaTa(`button-${name}`);
const input = (name) => qaTa(`input-${name}`);
const inputControl = (name) => `${input(name)}, ${input(name)} input, ${input(name)} textarea`;
const textField = (name) => testId(`textfield-${name}`);
const textFieldInput = (name) => `${textField(name)} input`;
const textFieldError = (name) => testId(`textfield-error-${name}`);
const select = (name) => qaTa(`select-${name}`);
const switchRoot = (name) => testId(`switch-${name}`);
const switchControl = (name) => `${switchRoot(name)} [role="switch"]`;
const checkbox = (name) => `${testId(`checkbox-${name}`)} input`;
const textarea = (name) => testId(`textarea-${name}`);
const textareaControl = (name) => `${textarea(name)}, ${textarea(name)} textarea`;
const card = (name) => testId(`card-${name}`);
const fileUpload = (name) => testId(`file-upload-${name}`);
const fileUploadInput = (name) => `input[type="file"][name="${name}"], ${fileUpload(name)} input[type="file"]`;
const tooltip = (name) => testId(`tooltip-${name}`);
const dialog = (id) => testId(id);
const dialogClose = (id) => `${dialog(id)} [data-testid="close"]`;
const dialogFooter = (id) => `${dialog(id)} [data-slot="dialog-footer"]`;
const dialogFooterAction = (id, name) => `${dialogFooter(id)} ${button(name)}`;
const datePicker = () => button('date-field-picker');
const pagination = {
    root: (position) => testId(`pagination-${position}`),
    page: (page) => button(`pagination-page-${page}`),
    next: () => button('pagination-next'),
    previous: () => button('pagination-previous'),
};
const results = {
    list: () => testId('search-results-list'),
    row: (index) => testId(`search-result-${index}`),
    empty: () => testId('search-results-empty'),
    error: () => testId('search-results-error'),
    loading: () => testId('search-results-loading'),
    statusDot: () => testId('status-dot'),
};
const TOASTER = '[data-sonner-toaster]';
const snackbar = {
    toaster: () => TOASTER,
    item: () => `${TOASTER} [data-sonner-toast]`,
    card: () => `${TOASTER} [data-sonner-toast] ${testId('card-notification-card')}`,
    alert: () => `${TOASTER} [data-sonner-toast] [role="alert"]`,
    status: () => `${TOASTER} [data-sonner-toast] [role="status"]`,
};
const notification = {
    inline: () => `main#main ${testId('card-notification-card')}`,
    message: (key) => testId(`inline-message-${key}`),
};
const shell = {
    main: () => 'main#main',
    logo: () => 'a[href$="/welcome"]',
    pageTitle: () => testId('page-title'),
    footerCopyright: () => testId('footer-copyright'),
    hamburger: () => button('admin-navigation-toggle'),
    navigationDrawer: () => testId('admin-navigation-drawer'),
    navItem: (slug) => testId(`nav-item-${slug}`),
    logout: () => button('admin-logout'),
    drawerLogout: () => button('admin-navigation-logout'),
    accountMenu: () => testId('admin-account-menu'),
    accountMenuName: () => testId('account-menu-name'),
    impersonationCountdown: () => testId('impersonation-countdown'),
    languageToggle: () => button('language-chooser-toggle'),
    languageOption: (locale) => button(`language-chooser-${locale}`),
    fontSize: (size) => button(`font-size-${size}`),
    backToOverview: () => button('back-to-overview'),
    backToList: () => button('back-to-list'),
    hydrateFallback: () => testId('hydrate-fallback'),
};
const routeError = {
    root: () => testId('app-route-error'),
    boundary: () => testId('root-error-boundary'),
    reload: () => button('route-error-reload'),
    home: () => button('route-error-home'),
};
/** Ids the webapp already emits, confirmed by probing the running app rather than assumed. */
const webappShell = {
    header: () => testId('nav-wrapper'),
    footer: () => testId('footer-webapp'),
    mainContent: () => testId('app-main-content'),
    navItem: (slug) => testId(`nav-item-${slug}`),
    logo: () => testId('nav-logo'),
    navigationToggle: () => testId('navigation-toggle'),
    languageMenu: () => testId('language-menu'),
    languageOptionInDrawer: (locale) => testId(`language-option-${locale}`),
    languageChooser: () => testId('language-chooser'),
    languageToggle: () => button('language-chooser-toggle'),
    languageOption: (locale) => button(`language-chooser-${locale}`),
    logout: () => button('logout'),
    accountMenu: () => testId('user'),
    notificationBell: () => testId('mail-notifications'),
    notificationBadge: () => testId('badge'),
    pageHeadline: () => testId('page-headline'),
    back: () => button('back'),
};
/** Each flow names its own stepper, for example stepper-checkout. */
const stepper = {
    root: (flow) => testId(`stepper-${flow}`),
    step: (flow, index) => `${testId(`stepper-${flow}`)} [data-step="${index}"]`,
    next: () => button('step-next'),
    back: () => button('back'),
};
const webappRows = {
    accountTab: (slug) => testId(`nav-item-${slug}`),
    addressCard: (id) => testId(`address-card-${id}`),
    medicationRow: (id) => testId(`medication-row-${id}`),
    prescriptionRow: (id) => testId(`prescription-row-${id}`),
    orderRow: (id) => testId(`order-row-${id}`),
    cartLine: (id) => testId(`cart-line-${id}`),
    planDay: (date) => testId(`plan-day-${date}`),
    planEntry: (id) => testId(`plan-entry-${id}`),
    searchResult: (id) => testId(`search-result-${id}`),
    potentialResult: (id) => testId(`potential-result-${id}`),
    empty: (name) => testId(`${name}-empty`),
};
const detailValue = (field) => testId(`detail-${field}`);
const chunkReloadGuardKey = (app) => `${app}:chunk-reload-build`;
const IDS = {
    navigationDrawer: 'admin-navigation-drawer',
    navItem: (slug) => `nav-item-${slug}`,
    accountMenu: 'admin-account-menu',
    accountMenuName: 'account-menu-name',
    impersonationCountdown: 'impersonation-countdown',
    languageChooserToggle: 'language-chooser-toggle',
    languageChooserOption: (locale) => `language-chooser-${locale}`,
    loginExternalError: 'login-external-error',
    loginSsoError: 'login-sso-error',
    searchResultsEmpty: 'search-results-empty',
    searchResultsError: 'search-results-error',
    searchResultsLoading: 'search-results-loading',
    searchResultsList: 'search-results-list',
    searchResult: (index) => `search-result-${index}`,
    statusDot: 'status-dot',
    detailValue: (field) => `detail-${field}`,
    inlineMessage: (key) => `inline-message-${key}`,
    textFieldError: (name) => `textfield-error-${name}`,
    onboardingBanner: 'onboarding-banner',
    pickPostBadgeNew: 'pickpost-badge-new',
    pickPostBadgeChanged: 'pickpost-badge-changed',
    pickPostLink: (id) => `pickpost-link-${id}`,
    pickPostSearchHintToggle: 'pickpost-search-hint-toggle',
    promotionsLastExport: 'promotions-last-export',
    promotionHeadlineCreate: 'promotion-headline-create',
    pageTitle: 'page-title',
    footerCopyright: 'footer-copyright',
    appRouteError: 'app-route-error',
    rootErrorBoundary: 'root-error-boundary',
    hydrateFallback: 'hydrate-fallback',
    medicine: (index) => `medicine-${index}`,
    cumulusPoint: (index) => `cumulus-point-${index}`,
    paginationRoot: (position) => `pagination-${position}`,
};
export { button, buttonQaTa, card, checkbox, chunkReloadGuardKey, datePicker, detailValue, dialog, dialogClose, dialogFooter, dialogFooterAction, fileUpload, fileUploadInput, IDS, input, inputControl, notification, pagination, qaTa, results, routeError, select, shell, snackbar, stepper, switchControl, switchRoot, testId, textarea, textareaControl, textField, textFieldError, textFieldInput, tooltip, webappRows, webappShell, };
